function randInt(max) {
  const a = new Uint32Array(1);
  crypto.getRandomValues(a);
  return a[0] % max;
}

// Strong, human-copyable temporary password. Excludes ambiguous chars (0/O, 1/l/I).
export function generatePassword(len = 12) {
  const U = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const L = "abcdefghijkmnpqrstuvwxyz";
  const D = "23456789";
  const S = "!@#$%*?";
  const all = U + L + D + S;
  const required = [U, L, D, S].map((s) => s[randInt(s.length)]);
  const rest = Array.from({ length: Math.max(0, len - required.length) }, () => all[randInt(all.length)]);
  const arr = [...required, ...rest];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = randInt(i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.join("");
}
